<div class="retry-container p-3 border border-danger">
    <p class="h5 font-weight-bold text-center text-danger mb-4">{{'This address could not be verified' | translate}}</p>

    <p class="mb-4 text-center">{{'You can either go back to edit the address or, if you\'re sure the address is correct, continue anyway' | translate}}</p>

    <div class="row align-items-end justify-content-center">
        <div class="col-auto text-center">
            <button (click)="retryEmitter.emit(true)"class="btn btn-primary">{{'Edit Address and Try Again' | translate}}</button>
        </div>
        <div class="col-auto text-center">
            <button (click)="retryEmitter.emit(false)"class="btn btn-success">{{'Continue Anyway' | translate}}</button>
        </div>
    </div>
</div>
